// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".policy-layers h1{padding:var(--drawer-padding);font-weight:600}", "",{"version":3,"sources":["webpack://./src/components/tool-drawers/layer-drawer/PolicyLayers.scss"],"names":[],"mappings":"AACE,kBACE,6BAAA,CACA,eAAA","sourcesContent":[".policy-layers {\n  h1 {\n    padding: var(--drawer-padding);\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
